import React from "react";
import theme from "theme";
import { Theme, Link, Image, Section, Text, Box, Strong } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { Override, SocialMedia } from "@quarkly/components";
import * as Components from "components";
import { MdMenu } from "react-icons/md";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"index"} />
		<Helmet>
			<title>
				Home | Website Example
			</title>
			<meta name={"description"} content={"It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."} />
			<meta property={"og:title"} content={"Home | Website Example"} />
			<meta property={"og:description"} content={"It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/favicon-32x32.png?v=2025-02-06T21:45:55.970Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/apple-touch-icon.png?v=2025-02-06T21:46:06.416Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/apple-touch-icon.png?v=2025-02-06T21:46:06.416Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/apple-touch-icon.png?v=2025-02-06T21:46:06.416Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/apple-touch-icon.png?v=2025-02-06T21:46:06.416Z"} />
		</Helmet>
		<Section padding="16px 0 16px 0" quarkly-title="Header" align-items="center" justify-content="center">
			<Override
				slot="SectionContent"
				md-margin="0px 16px 0px 16px"
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				md-grid-template-columns="repeat(2, 1fr)"
				margin="0px 32px 0px 32px"
				width="100%"
			/>
			<Link transition="opacity 200ms ease" quarkly-title="Link" href="/" position="relative">
				<Image
					src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16:03:14.619Z"
					width="120px"
					z-index="3"
					srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=3200 3200w"
					sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
				/>
			</Link>
			<Components.BurgerMenu md-display="flex" md-align-items="center" md-justify-content="flex-end" justify-self="auto">
				<Override slot="icon-open" md-position="fixed" md-top="18px" md-right="18px" />
				<Override
					slot="menu"
					md-top={0}
					md-width="100%"
					justify-content="center"
					lg-transition="transform 400ms ease 0s"
					md-position="fixed"
					display="flex"
					md-left={0}
					lg-transform="translateY(0px) translateX(0px)"
					md-height="100%"
					padding="0px 0 0px 0"
					align-items="center"
				>
					<Override
						slot="item"
						md-padding="16px 40px 16px 40px"
						display="inline-block"
						text-transform="uppercase"
						text-align="center"
						padding="8px 20px 8px 20px"
					/>
					<Override slot="item-404" lg-display="none" display="none" />
					<Override slot="item-index" lg-display="none" display="none" />
					<Override
						slot="link"
						md-hover-opacity="1"
						md-active-opacity="1"
						md-color="--dark"
						font="--base"
						text-transform="initial"
						md-font="16px/24px sans-serif"
						text-decoration-line="initial"
						color="--dark"
						transition="opacity .15s ease 0s"
						letter-spacing="0.5px"
						md-opacity=".5"
						md-transition="opacity .15s ease 0s"
						opacity=".5"
						hover-opacity="1"
					/>
					<Override
						slot="link-active"
						md-opacity="1"
						md-cursor="default"
						opacity="1"
						color="--primary"
						cursor="default"
					/>
				</Override>
				<Override slot="icon,icon-close" category="md" icon={MdMenu} />
				<Override
					slot="icon"
					category="md"
					icon={MdMenu}
					size="36px"
					md-right="0px"
					md-position="relative"
				/>
				<Override
					slot="menu-open"
					md-justify-content="center"
					md-top={0}
					md-bottom={0}
					md-display="flex"
					md-flex-direction="column"
					md-align-items="center"
				/>
			</Components.BurgerMenu>
		</Section>
		<Section
			box-sizing="border-box"
			lg-padding="50px 30px 50px 30px"
			id="mission"
			padding="90px 0px 100px 0px"
			quarkly-title="About"
			border-color="--color-lightD2"
			border-style="solid"
			border-width="1px 0px 1px 0px"
			sm-padding="24px 0 24px 0"
			background="--color-lightD1"
			justify-content="center"
		>
			<Override
				slot="SectionContent"
				md-margin="0px 16px 0px 16px"
				align-items="center"
				width="100%"
				min-width="auto"
				margin="0px 32px 0px 32px"
			/>
			<Text
				letter-spacing="1px"
				color="--dark"
				text-align="center"
				width="85%"
				lg-font="--lead"
				sm-font="--base"
				font="normal 500 28px/1.2 'AvenirNextCyrRegular', sans-serif"
				margin="0px 0px 0px 0px"
			>
				Pantry Mastering provides top-tier mastering and mixing services that are both high-quality and affordable. Founded by sound engineer Taz Mattar, we bring a wealth of industry experience to ensure your music sounds polished and professional on all platforms.
			</Text>
		</Section>
		<Section sm-padding="60px 0 60px 0" padding="65px 0 65px 0" quarkly-title="Images-9">
			<Override slot="SectionContent" flex-direction="row" flex-wrap="wrap" />
			<Box
				sm-margin="0px 0px 30px 0px"
				flex-direction="column"
				display="flex"
				width="25%"
				lg-width="100%"
				margin="0px 0px 0px 0px"
				padding="16px 16px 16px 16px"
				sm-padding="0px 0px 0px 0px"
				border-radius="20px"
			>
				<Box
					width="100%"
					position="relative"
					transition="transform 0.2s ease-in-out 0s"
					height="auto"
					overflow-x="hidden"
					overflow-y="hidden"
					transform="translateY(0px)"
					hover-transform="translateY(-10px)"
					padding="0px 0px 150% 0px"
					border-radius="20px"
				>
					<Image
						left={0}
						min-height="100%"
						top={0}
						right={0}
						bottom={0}
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0362.jpg?v=2025-01-28T16:54:25.254Z"
						object-fit="cover"
						position="absolute"
						display="block"
						width="100%"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0362.jpg?v=2025-01-28T16%3A54%3A25.254Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0362.jpg?v=2025-01-28T16%3A54%3A25.254Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0362.jpg?v=2025-01-28T16%3A54%3A25.254Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0362.jpg?v=2025-01-28T16%3A54%3A25.254Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0362.jpg?v=2025-01-28T16%3A54%3A25.254Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0362.jpg?v=2025-01-28T16%3A54%3A25.254Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0362.jpg?v=2025-01-28T16%3A54%3A25.254Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
			</Box>
			<Box
				display="flex"
				width="25%"
				lg-width="100%"
				margin="0px 0px 0px 0px"
				padding="16px 16px 16px 16px"
				sm-padding="0px 0px 0px 0px"
				sm-margin="0px 0px 30px 0px"
				flex-direction="column"
			>
				<Box
					width="100%"
					height="auto"
					overflow-y="hidden"
					transition="transform 0.2s ease-in-out 0s"
					hover-transform="translateY(-10px)"
					padding="0px 0px 150% 0px"
					overflow-x="hidden"
					position="relative"
					transform="translateY(0px)"
				>
					<Image
						bottom={0}
						min-height="100%"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0395.jpg?v=2025-01-28T16:56:48.371Z"
						object-fit="cover"
						width="100%"
						top={0}
						position="absolute"
						display="block"
						left={0}
						right={0}
						border-radius="20px"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0395.jpg?v=2025-01-28T16%3A56%3A48.371Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0395.jpg?v=2025-01-28T16%3A56%3A48.371Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0395.jpg?v=2025-01-28T16%3A56%3A48.371Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0395.jpg?v=2025-01-28T16%3A56%3A48.371Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0395.jpg?v=2025-01-28T16%3A56%3A48.371Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0395.jpg?v=2025-01-28T16%3A56%3A48.371Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/IMG_0395.jpg?v=2025-01-28T16%3A56%3A48.371Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
			</Box>
			<Box
				sm-padding="0px 0px 0px 0px"
				padding="16px 16px 16px 16px"
				lg-order="1"
				width="25%"
				align-items="flex-start"
				lg-width="100%"
				lg-align-items="center"
				lg-margin="0px 0px 0px 0px"
				sm-margin="0px 0px 0px 0px"
				display="flex"
				flex-direction="column"
				lg-padding="0px 16px 16px 16px"
			>
				<Text
					lg-text-align="center"
					sm-margin="30px 0px 0px 0px"
					margin="0px 0px 0px 0px"
					color="--darkL2"
					font="--base"
					md-text-align="left"
				>
					Taz’s journey into the world of recording began at the age of 15 with work experience at Presshouse Studios in Devon, known for hosting Martin Barre of Jethro Tull. This early opportunity ignited a lifelong passion for music and sound engineering.
					<br />
					<br />
					A pivotal point in Taz’s career came during his time at the renowned Sarm West Studios in London, where he worked alongside a diverse range of artists and producers. Rising through the ranks, he honed his craft under the guidance of industry icons such as Trevor Horn, Danton Supple, Julian Mendelsohn, and Steve Lipson.
					<br />
					<br />
					Following his time at Sarm, Taz went on to master and mix records for independent artists, small labels, mainstream TV companies, and major record labels. His career has included collaborations with celebrated artists such as Sia, Mark Ronson, Coldplay, Pet Shop Boys, Seal, Megadeth, Gorillaz, and the Rolling Stones.
				</Text>
			</Box>
		</Section>
		<Section
			sm-padding="24px 0 24px 0"
			background="--color-lightD1"
			border-style="solid"
			box-sizing="border-box"
			justify-content="center"
			padding="90px 0px 100px 0px"
			border-color="--color-lightD2"
			border-width="1px 0px 1px 0px"
			lg-padding="50px 30px 50px 30px"
			quarkly-title="FAQ"
		>
			<Override
				slot="SectionContent"
				width="100%"
				min-width="auto"
				margin="0px 48px 0px 48px"
				md-margin="0px 16px 0px 16px"
				align-items="center"
			/>
			<Text
				font="--base"
				margin="0px 0px 10px 0px"
				text-transform="uppercase"
				lg-margin="0px 0px 6px 0px"
				quarkly-title="Title"
				letter-spacing="1px"
				color="--dark"
				opacity="0.6"
				text-align="center"
				lg-text-align="center"
			>
				here to help
			</Text>
			<Text
				sm-font="--headline3"
				md-font="--headline3"
				font="--headline2"
				margin="0px 0px 64px 0px"
				color="--dark"
				text-align="center"
				lg-text-align="center"
				lg-margin="0px 0px 36px 0px"
			>
				FAQ
			</Text>
			<Box
				width="100%"
				display="grid"
				grid-gap="32px"
				grid-template-columns="repeat(4, 1fr)"
				lg-grid-template-columns="repeat(2, 1fr)"
				md-grid-template-columns="1fr"
			>
				<Box>
					<Text
						text-align="center"
						md-text-align="left"
						font="--lead"
						margin="0px 0px 0px 0px"
						color="--dark"
					>
						What formats do you deliver?
					</Text>
					<Text
						text-align="center"
						margin="16px 0px 0px 0px"
						md-text-align="left"
						sm-margin="8px 0px 0px 0px"
						font="--base"
						color="--darkL2"
						opacity="0.6"
						lg-text-align="center"
					>
						We provide masters in WAV, AIFF, and MP3 formats, along with DDP files for CD replication. Let us know if you need additional formats.
					</Text>
				</Box>
				<Box>
					<Text
						margin="0px 0px 0px 0px"
						color="--dark"
						text-align="center"
						md-text-align="left"
						font="--lead"
					>
						Do you master specifically for streaming services?
					</Text>
					<Text
						lg-text-align="center"
						text-align="center"
						margin="16px 0px 0px 0px"
						md-text-align="left"
						sm-margin="8px 0px 0px 0px"
						font="--base"
						color="--darkL2"
						opacity="0.6"
					>
						Yes, we optimise masters for platforms like Spotify, Apple Music, and TIDAL, ensuring they meet loudness and encoding standards for the best playback experience.
					</Text>
				</Box>
				<Box>
					<Text
						color="--dark"
						text-align="center"
						md-text-align="left"
						font="--lead"
						margin="0px 0px 0px 0px"
					>
						Can you master for vinyl?
					</Text>
					<Text
						font="--base"
						color="--darkL2"
						opacity="0.6"
						lg-text-align="center"
						text-align="center"
						margin="16px 0px 0px 0px"
						md-text-align="left"
						sm-margin="8px 0px 0px 0px"
					>
						Absolutely. Vinyl mastering requires a different approach to ensure optimal dynamics and frequency balance for the format. We provide high-resolution pre-masters tailored for vinyl cutting.
					</Text>
				</Box>
				<Box>
					<Text
						font="--lead"
						margin="0px 0px 0px 0px"
						color="--dark"
						text-align="center"
						md-text-align="left"
					>
						How should I prepare my mix for mastering?
					</Text>
					<Text
						lg-text-align="center"
						text-align="center"
						margin="16px 0px 0px 0px"
						md-text-align="left"
						sm-margin="8px 0px 0px 0px"
						font="--base"
						color="--darkL2"
						opacity="0.6"
					>
						Ensure your mix is in WAV or AIFF format, preferably at 24-bit or 32-bit, with a sample rate of at least 44.1kHz. Leave -3dB to -6dB of headroom and avoid limiting on the master bus. All audio should be delivered via wetransfer or you can use our own self-hosted platform at{" "}
						<Strong>
							pantrynetwork.io
						</Strong>
					</Text>
				</Box>
			</Box>
		</Section>
		<Section padding="80px 0 80px 0" quarkly-title="Customers" lg-padding="50px 0 50px 0" justify-content="center">
			<Override
				slot="SectionContent"
				min-width="auto"
				margin="0px 32px 0px 32px"
				align-items="center"
				width="100%"
				md-margin="0px 16px 0px 16px"
			/>
			<Text
				text-align="center"
				lg-text-align="center"
				sm-margin="0px 0px 48px 0px"
				sm-font="--headline3"
				md-font="--headline3"
				font="--headline2"
				margin="0px 0px 64px 0px"
				color="--dark"
			>
				Clients
			</Text>
			<Section padding="65px 0 65px 0" sm-padding="60px 0 60px 0" quarkly-title="Images-17" inner-max-width="40%">
				<Override slot="SectionContent" flex-direction="row" flex-wrap="wrap" />
				<Box
					sm-grid-template-columns="repeat(2, 1fr)"
					grid-auto-flow="row"
					grid-template-columns="repeat(8, 1fr)"
					grid-gap="10px 10px"
					grid-template-rows="repeat(2, 117px)"
					lg-grid-template-rows="repeat(4, 117px)"
					lg-align-self="center"
					lg-grid-gap="36px"
					width="100%"
					display="flex"
					padding="16px 0px 16px 0px"
					lg-grid-template-columns="repeat(4, 1fr)"
				>
					<Box
						overflow-x="hidden"
						transform="translateY(0px)"
						display="flex"
						align-items="center"
						justify-content="center"
						overflow-y="hidden"
						position="relative"
						transition="transform 0.2s ease-in-out 0s"
						hover-transform="translateY(-10px)"
						padding="0px 0px 0px 0px"
					>
						<Image
							object-fit="cover"
							position="relative"
							width="112px"
							left={0}
							right={0}
							bottom="0px"
							min-height="100%"
							height="112px"
							src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/decca.png?v=2025-01-28T17:21:27.633Z"
							display="block"
							top="auto"
							srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/decca.png?v=2025-01-28T17%3A21%3A27.633Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/decca.png?v=2025-01-28T17%3A21%3A27.633Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/decca.png?v=2025-01-28T17%3A21%3A27.633Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/decca.png?v=2025-01-28T17%3A21%3A27.633Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/decca.png?v=2025-01-28T17%3A21%3A27.633Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/decca.png?v=2025-01-28T17%3A21%3A27.633Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/decca.png?v=2025-01-28T17%3A21%3A27.633Z&quality=85&w=3200 3200w"
							sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
						/>
					</Box>
					<Image
						width="112px"
						top="auto"
						right={0}
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/wotnot.png?v=2025-01-28T17:24:47.301Z"
						position="relative"
						display="block"
						left={0}
						bottom="0px"
						min-height="100%"
						height="112px"
						object-fit="cover"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/wotnot.png?v=2025-01-28T17%3A24%3A47.301Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/wotnot.png?v=2025-01-28T17%3A24%3A47.301Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/wotnot.png?v=2025-01-28T17%3A24%3A47.301Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/wotnot.png?v=2025-01-28T17%3A24%3A47.301Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/wotnot.png?v=2025-01-28T17%3A24%3A47.301Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/wotnot.png?v=2025-01-28T17%3A24%3A47.301Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/wotnot.png?v=2025-01-28T17%3A24%3A47.301Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
					<Box
						padding="0px 0px 0px 0px"
						align-items="center"
						display="flex"
						overflow-x="hidden"
						overflow-y="hidden"
						position="relative"
						transform="translateY(0px)"
						hover-transform="translateY(-10px)"
						transition="transform 0.2s ease-in-out 0s"
						justify-content="center"
					>
						<Image
							src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/molecularsound.jpg?v=2025-01-28T17:25:19.025Z"
							object-fit="cover"
							top="auto"
							left={0}
							bottom="0px"
							min-height="100%"
							height="112px"
							position="relative"
							display="block"
							width="112px"
							right={0}
							overflow="visible"
							srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/molecularsound.jpg?v=2025-01-28T17%3A25%3A19.025Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/molecularsound.jpg?v=2025-01-28T17%3A25%3A19.025Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/molecularsound.jpg?v=2025-01-28T17%3A25%3A19.025Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/molecularsound.jpg?v=2025-01-28T17%3A25%3A19.025Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/molecularsound.jpg?v=2025-01-28T17%3A25%3A19.025Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/molecularsound.jpg?v=2025-01-28T17%3A25%3A19.025Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/molecularsound.jpg?v=2025-01-28T17%3A25%3A19.025Z&quality=85&w=3200 3200w"
							sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
						/>
					</Box>
					<Box
						position="relative"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						transform="translateY(0px)"
						transition="transform 0.2s ease-in-out 0s"
						hover-transform="translateY(-10px)"
						align-items="center"
						display="flex"
						justify-content="center"
					>
						<Image
							top="auto"
							bottom="0px"
							min-height="100%"
							height="112px"
							src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/btsport.png?v=2025-01-28T17:27:08.694Z"
							object-fit="cover"
							position="relative"
							display="block"
							width="112px"
							left={0}
							right={0}
							srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/btsport.png?v=2025-01-28T17%3A27%3A08.694Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/btsport.png?v=2025-01-28T17%3A27%3A08.694Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/btsport.png?v=2025-01-28T17%3A27%3A08.694Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/btsport.png?v=2025-01-28T17%3A27%3A08.694Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/btsport.png?v=2025-01-28T17%3A27%3A08.694Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/btsport.png?v=2025-01-28T17%3A27%3A08.694Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/btsport.png?v=2025-01-28T17%3A27%3A08.694Z&quality=85&w=3200 3200w"
							sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
						/>
					</Box>
				</Box>
			</Section>
		</Section>
		<Section
			margin="0 0 0 0"
			padding="16px 0 16px 0"
			box-sizing="border-box"
			quarkly-title="Footer"
			justify-content="center"
		>
			<Override
				slot="SectionContent"
				width="100%"
				md-margin="0px 16px 0px 16px"
				min-width="auto"
				margin="0px 32px 0px 32px"
			/>
			<Box
				grid-gap="32px"
				width="100%"
				grid-template-columns="repeat(2, 1fr)"
				sm-grid-gap="16px"
				display="grid"
			>
				<Box display="flex" align-items="center" sm-flex-wrap="wrap">
					<Image width="28px" height="28px" src="https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/default-website-quarkly-logo-grey.svg?v=2020-11-06T17:24:35.270Z" />
					<Link
						white-space="nowrap"
						font="--base"
						opacity="0.6"
						text-align="left"
						margin="1px 0px 0px 10px"
						href="https://quarkly.io/"
						color="--dark"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
					>
						Made on Quarkly
					</Link>
				</Box>
				<SocialMedia instagram="https://www.instagram.com/pantrymastering?igsh=MWJnbzF4cjVlb3Fhbw%3D%3D&utm_source=qr" justify-content="flex-end">
					<Override slot="link" background="none" border-radius="50%" />
					<Override slot="icon" color="--dark" />
				</SocialMedia>
			</Box>
		</Section>
		<Link
			font={"--capture"}
			font-size={"10px"}
			position={"fixed"}
			bottom={"12px"}
			right={"12px"}
			z-index={"4"}
			border-radius={"4px"}
			padding={"5px 12px 4px"}
			background-color={"--dark"}
			opacity={"0.6"}
			hover-opacity={"1"}
			color={"--light"}
			cursor={"pointer"}
			transition={"--opacityOut"}
			quarkly-title={"Badge"}
			text-decoration-line={"initial"}
			href={"https://quarkly.io/"}
			target={"_blank"}
		>
			Made on Quarkly
		</Link>
	</Theme>;
});